export default "__VITE_ASSET__24630144__"